'use strict';

DoohApps
    .factory('SoftwareHardwareComplianceData', ['restApi', function (restApi) {
        var controllerName = 'MediaScreen/';

        return {
            getComplianceList: function (successCallback) {
                restApi.GetApiMethod(successCallback, controllerName + 'GetSoftwareHardwareComplianceList');
            },
            updateCompliance: function (successCallback, swhwCompliance) {
                restApi.PutApiMethod(successCallback, controllerName + 'PutSoftwareHardwareCompliance', swhwCompliance);
            },
            addCompliance: function (successCallback, swhwCompliance) {
                restApi.PostApiMethod(successCallback, controllerName + 'PostSoftwareHardwareCompliance', swhwCompliance);
            },
            deleteCompliance: function (successCallback, id) {
                restApi.DeleteApiMethod(successCallback, controllerName + 'DeleteSoftwareHardwareCompliance?Id=' + id);
            },
            checkMatchcode: function (successCallback, code) {
                restApi.GetApiMethod(successCallback, controllerName + 'CheckMatchCode?code='+code);
            },
            getCompaniesUsingCompliance: function (successCallback, id) {
                restApi.GetApiMethod(successCallback, controllerName + 'GetCompaniesUsingCompliance?id=' + id);
            },
        }
    }])
